module.exports = __webpack_public_path__ + "img/chat_user_offline.ab06dbd2.svg";